// extracted by mini-css-extract-plugin
export default {"warn":"QuoteAvailableTill_warn__oSOPk","info":"QuoteAvailableTill_info__zjEWV"};